/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_SavingInputs */



/**
* | output |
* | --- |
* | "Saving" |
*
* @param {User_SavingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_saving = /** @type {((inputs?: User_SavingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_SavingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardando")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvando")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio")
	return /** @type {LocalizedString} */ ("Saving")
});